<template>
  <div ref="lastArticlesHeader" class="lastArticlesContainer">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-icon @click="goBack">
        mdi-chevron-left
      </v-icon>

      <v-toolbar-title class="pageTitle">
        <span>Bestelldetails</span>
      </v-toolbar-title>

    </v-toolbar>
    <v-divider class="headerDivider"/>
    <div class="contentWrapper virtual-padding" ref="contentWrapper">
      <!--<product-list :renderData="renderData" v-if="!isLoading"/>-->

      <v-virtual-scroll class="order_virtual-scroll" item-height="210"
                        v-if="!isLoading" :items="renderData.products"
                        bench="1" ref="vscroll">
        <template v-slot:default="{index, item}">
          <v-card class="articleCard"
                  elevation="0"
                  v-bind:class="{cartItem: renderData.cart && !renderData.order}"
                  light
                  :key="index"
          >
            <v-list-item three-line @click="goToArticle(item.itemNo)">
              <v-list-item-avatar tile>
                <!--
                <v-img :src="loadProductImage(item.itemNo)"
                       lazy-src=""
                       contain
                >
                -->
                <v-img :src="baseUrl + 'storage/webps/'+ (item.itemNo.indexOf('-') > -1 ? item.itemNo.substr(0, item.itemNo.indexOf('-')) : item.itemNo)+'.webp'"
                       lazy-src=""
                       contain
                >
                  <template v-slot:placeholder>
                    <v-skeleton-loader type="avatar" tile>

                    </v-skeleton-loader>
                  </template>
                </v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-container>
                  <v-row class="articleCard__details">
                    <v-col cols="12"
                           class="articleNameSmall textEllipsis"
                    >
                      {{ item.description }}
                    </v-col>
                    <div class="articleAdditionalInfoWrapper">
                      <v-col cols="12" v-if="renderData.cart || renderData.category || renderData.deposit" class="textSize__14 text--black pb-0 pt-2">
                        <span class="articleAdditionalInfo">Artikelnummer: {{ item.itemNo}}</span>
                      </v-col>
                    </div>
                    <v-col cols="12" v-if="item.availability === 'G' && !renderData.deposit" class="articleStatusCol">
                      <div class="articleAvailable"></div>
                      <span class="articleStatusAvailable">Artikel ist lieferbar</span>
                    </v-col>
                    <v-col cols="12" v-if="item.availability ==='R' && !renderData.deposit" class="articleStatusCol">
                      <div class="articleNotAvailable"></div>
                      <span class="articleStatusNotAvailable"
                            v-if="!item.delisted"
                      >
                        Artikel ist derzeit nicht lieferbar
                      </span>
                      <span class="articleStatusNotAvailable"
                            v-if="item.delisted"
                      >
                        Artikel ist ausgelistet
                      </span>
                    </v-col>
                    <v-col cols="12" v-if="item.availability==='Y'" class="articleStatusCol">
                      <div class="articlePending"></div>
                      <span class="articleStatusPending textEllipsis">Bestellartikel - wird nach Eintreffen automatisch ausgeliefert</span>
                    </v-col>

                    <v-col cols="9" v-if="!renderData.cart && !renderData.deposit">


                      <div class="discountRibbonWrap"
                           v-if="item.price.length > 0 && item.price[0].action === 1"
                      >
                        <div class="discountRibbon">
                        </div>
                        <div class="discountRibbonContent">
                          <span class="ribbonText">Aktion</span>
                        </div>
                      </div>


                      <span class="articlePriceMain" v-if="item.price.length > 0 && item.price[0].price > 0">{{ item.price[0].price | parsePrice }} € </span>
                      <span class="articlePriceMain" v-if="item.price.length === 0 && item.default_price.uvp > 0">{{ item.default_price.uvp | parsePrice }} € </span>
                      <span class="articlePriceUVP" v-if="item.price.length > 0 && item.price[0].uvp !== null"> UVP: {{ item.price[0].uvp | parsePrice }} € </span>
                      <span class="articlePriceUVP" v-if="item.price.length > 0 && (item.price[0].uvp === null && item.default_price.uvp >0)"> UVP: {{ item.default_price.uvp | parsePrice }} € </span>
                      <span class="articlePriceUVP" v-if="item.price.length === 0 && (item.default_price.uvp !== null && item.default_price.uvp > 0)"> UVP: {{ item.default_price.uvp | parsePrice }} € </span>
                    </v-col>

                    <v-col cols="3">
                      <addToCart :article="item" class="listAddToCartFormButton" v-if="renderData.watchlist && (item.availability === 'G' || item.availability === 'Y')"/>
                    </v-col>

                    <v-col v-if="renderData.cart" cols="12" class="articleAmountCart">
                      <span v-if="item.itemNo.indexOf('-') !== -1">
                        {{ item.itemNo.substr(item.itemNo.indexOf('-')+1) * item.orderedAmount }}
                      </span>
                      <span v-else>
                        {{ item.orderedAmount }}
                      </span>
                      <span v-if="item.itemNo.indexOf('-') !== -1">
                        {{ item.orderedType | capitalize }}
                      </span>
                      <span v-else>
                        {{ item.orderedType | capitalize }}
                      </span>
                    </v-col>
                    <v-col v-if="renderData.cart" cols="12" class="pa-0">
                      <span class="articlePriceMain">{{ item.totalPriceArticle | parsePrice }} €</span>
                    </v-col>
                  </v-row>
                </v-container>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </template>
      </v-virtual-scroll>

      <v-container class="lastArticlesWrapper" v-if="isLoading">

        <v-row
            class="articleCardRow"
        >
          <v-col cols="12"
                 class="articleCardCol"
                 v-for="index in 10"
                 :key="index"
          >
            <v-card class="articleCard"
                    elevation="0"
                    v-bind:class="{cartItem: renderData.cart && !renderData.order}"
                    light
            >
              <v-list-item three-line class="skeletonWrapper__li">
                <v-list-item-avatar tile>

                </v-list-item-avatar>

                <v-list-item-content>
                  <v-container>
                    <v-row class="articleCard__details">
                      <v-col cols="12"
                             class="articleNameSmall"
                      >
                        <v-skeleton-loader type="text"/>
                      </v-col>
                      <div class="articleAdditionalInfoWrapper">
                        <v-col cols="12" class="pb-0 pt-2">
                          <v-skeleton-loader type="text"/>
                        </v-col>
                      </div>
                      <v-col cols="12" class="articleStatus">
                        <v-skeleton-loader type="text"/>
                      </v-col>
                      <v-col cols="12" class="articleAmountCart">
                        <v-skeleton-loader type="text"/>
                      </v-col>
                      <v-col cols="12" class="pa-0 articlePrice">
                        <v-skeleton-loader type="text"/>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
//import productList from "@/app/productListing/productList"
import { mapGetters, mapMutations } from "vuex";
import router from '@/router'
import axios from 'axios'
import {api} from "@/config/api";
import scrollToPreviousPositionMixin from "@/app/productListing/mixins/scrollToPreviousPositionMixin";

export default {
  name: "singleOrder",
  mixins: [scrollToPreviousPositionMixin],
  components: {
    //productList,
  },
  data:() => {
    return {
      renderData: {cart: true, category: false, checkout:true, order:true, products: [], name: 'Bestelldetails'},
      isLoading: true,
      reorder: false,
      totalPrice: '',
      baseUrl: api.url
    }
  },

  methods: {
    ...mapGetters({
      getOrder: 'getOrder'
    }),
    ...mapMutations({
      setCartDrawerState: 'setCartDrawerState'
    }),

    goBack() {
      router.go(-1)
    },

    loadProductImage(artNr) {
      let adjustedArtNr = null
      if (artNr.indexOf('-') === -1) {
        adjustedArtNr = artNr
      }
      else {
        adjustedArtNr = artNr.substr(0,artNr.indexOf('-'))
      }
      return 'api/pic/'+adjustedArtNr
    },

    goToArticle(artNr) {
      this.setScrollPositionRef()
      this.$router.push({name: 'Artikeldetails', params: {id: artNr}})
    },
  },

  mounted() {
    if(this.getOrder() === null) {
      router.push({name: 'Bestellungen'})
    }
    else {

      let id = router.currentRoute.params.id
      axios.get('api/singleOrder/'+id).then((result) => {
        this.renderData.products = result.data.cartContent
        this.totalPrice = result.data.totalPrice
        this.isLoading = false
      })

    }
  },

  computed: {
    ...mapGetters({
      getCartContent: 'getCartContent'
    })
  }
}
</script>

<style>
  .order_virtual-scroll {
    padding-top: 20px;
    min-width: 345px;
    width: 100%;
    height: 100vh;
  }

  .v-virtual-scroll.order_virtual-scroll {
    padding-bottom: 70px;
    padding-top: 10px;
  }

  .order_virtual-scroll .v-virtual-scroll__container .v-virtual-scroll__item {
    margin-top: 10px;
  }
</style>
